import { differenceInDays, formatDistance, parseISO } from 'date-fns';
import { Session } from '../../services/chat/getSessions.service';

const calcGroup = (dateStr: string): string => {
  const now = new Date();
  const date = parseISO(dateStr);
  const days = differenceInDays(now, date);

  if (days < 1) {
    return 'Today';
  }

  if (days === 1) {
    return 'Yesterday';
  }

  const group = formatDistance(date, now, { addSuffix: true });

  return group[0].toUpperCase() + group.substring(1);
};

interface Group {
  group: string;
  sessions: Session[];
}

export const groupSessions = (sessions: Session[]): Group[] =>
  Object.values(
    [...sessions]
      .sort((a, b) => parseISO(b.session_dtm).getTime() - parseISO(a.session_dtm).getTime())
      .filter((item) => !!item.session_history[0]?.query)
      .reduce((acc: Record<string, Group>, session) => {
        const group = calcGroup(session.session_dtm);

        if (!acc[group]) {
          acc[group] = {
            group,
            sessions: [],
          };
        }

        acc[group].sessions.push(session);

        return acc;
      }, {})
  );
